import Items from './collections/items'

// Singleton of all products that are loaded or going to be loaded
export default new Items()
